import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Part';

const routes = [
    {
        matchRegex: '/Part/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail'),
        slots: [
            SLOT_KEY.SLOT_SECTION,
            SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
            SLOT_KEY.SLOT_V_SECTION,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'part-stock-unit', label: 'Part Stock Unit' },
                { key: 'part-stock-unit-test', label: 'Test' },
            ],
            [SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN]: [
                { key: 'table-link-supplier-header', label: 'Table "Link supplier" header' },
                { key: 'table-link-supplier-body', label: 'Table "Link supplier" body' }
            ],
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'linked-supplier', label: 'Linked Supplier' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_SUPPLIER_RATE_UPDATE', label: 'Supplier rate update' },
                { key: 'MARKETPLACE_EVENT_GET_SUPPLIER_SUCCESS', label: 'Get supplier success' },
            ],
        },
        replaceElements: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'part-unit-element', label: 'Part Unit Element' },
            ],
        },
    },
    {
        matchRegex: '/Part/Create',
        name: 'Part - Create',
        slots: [
            SLOT_KEY.SLOT_SECTION,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'part-stock-unit', label: 'Part Stock Unit' },
            ],
        },
        replaceElements: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'part-unit-element', label: 'Part Unit Element' },
            ],
        },
    },
]

export default routes;